import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective } from './directives/trans.directive';
import { TranslateAltDirective } from './directives/trans-alt.directive';
import { TranslatePlaceholderDirective } from './directives/trans-placeholder.directive';



@NgModule({
  exports: [
    TranslateDirective,
    TranslateAltDirective,
    TranslatePlaceholderDirective,
  ],
  imports: [
    CommonModule,
    TranslateDirective,
    TranslateAltDirective,
    TranslatePlaceholderDirective,
  ],
})
export class I18nModule { }
